import './App.css';
import Modal from './Components/Modal';


function App() {
  
  return (
    <div className="App">
     <Modal/>
    </div>
  );
}

export default App;
